import React, { useEffect } from "react";
import ReactMarkdown from "react-markdown";
import { HashLink } from "react-router-hash-link";
import DeadlineScrollBar from "../Deadline_ScrollBar/Deadline_ScrollBar";
import Footer from "../Footer/Footer";
import TermsData from "./TermsConditionData";
const TermsCondition = () => {
  const scrollWithOffset = (el) => {
    // const yCoordinate = el.getBoundingClientRect().top + window.offsetTop;
    // const yOffset = 100;
    // setTimeout(() => {
    window.scrollTo({
      top: document.body.offsetHeight + 100,
      behavior: "smooth",
      block: "end",
    });
    // }, 200);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <DeadlineScrollBar></DeadlineScrollBar>
      <div className="container" style={{ marginTop: "80px", fontSize: "1em" }}>
        <nav aria-label="breadcrumb" style={{ marginTop: "78px" }}>
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <HashLink
                smooth
                to="/#footer"
                scroll={(el) => scrollWithOffset(el)}
              >
                Home
              </HashLink>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Terms & Condition
            </li>
          </ol>
        </nav>
        {TermsData.map((data) => (
          <p style={{ fontSize: "1em" }}>
            <ReactMarkdown className="markdown" key={data.id}>
              {data.article}
            </ReactMarkdown>
          </p>
        ))}
        <nav aria-label="breadcrumb" style={{ marginTop: "78px" }}>
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <HashLink
                smooth
                to="/#footer"
                scroll={(el) => scrollWithOffset(el)}
              >
                Home
              </HashLink>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Terms & Condition
            </li>
          </ol>
        </nav>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default TermsCondition;
